"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    DIALOG_CLOSE_TIMEOUT: true,
    VOUCHER_CODE_INPUT_NAME: true,
    PLACE_ORDER_FALLBACK_TIMEOUT: true
};
exports.VOUCHER_CODE_INPUT_NAME = exports.PLACE_ORDER_FALLBACK_TIMEOUT = exports.DIALOG_CLOSE_TIMEOUT = void 0;
var _constantsGenerated = require("../constants-generated");
Object.keys(_constantsGenerated).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _constantsGenerated[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _constantsGenerated[key];
        }
    });
});
var _defaultTranslations = require("./defaultTranslations");
Object.keys(_defaultTranslations).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _defaultTranslations[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _defaultTranslations[key];
        }
    });
});
const DIALOG_CLOSE_TIMEOUT = exports.DIALOG_CLOSE_TIMEOUT = 2000;
const VOUCHER_CODE_INPUT_NAME = exports.VOUCHER_CODE_INPUT_NAME = 'voucherCode';
const PLACE_ORDER_FALLBACK_TIMEOUT = exports.PLACE_ORDER_FALLBACK_TIMEOUT = 10000;
